import { createTour } from './_baseTour'
import { DEFAULT_OPTIONS } from "vue-tour/src/shared/constants";
import store from '@/store';
import vuetify from "@/plugins/vuetify";
import router from "@/router";

function waitForElement(selector, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const interval = 100
    let elapsed = 0

    const check = () => {
      const el = document.querySelector(selector)
      if (el) return resolve(el)
      elapsed += interval
      if (elapsed >= timeout) reject(new Error(`Element ${selector} not found`))
      else setTimeout(check, interval)
    }

    check()
  })
}

export default createTour({
  id: 'onboarding',

  steps: [
    {
      target: "#tour-step-doctor-settings",
      title: '請先編輯你的「公開醫師資訊頁」',
      content: "這是病人在網路上搜尋時會看到的個人頁面，<br>編輯時間5分鐘，即可建立患者對您的第一印象和信任感",
      route: "/",
      params: {
        // placement: 'right'
      },
      highlight: true,
      overlay: true,
      before: () => new Promise((resolve) => {
        store.commit('navigation/setDrawerOpen', true);
        store.commit('tour/lockNavDrawer', true);
        resolve();
      }),
      after: () => new Promise((resolve) => {
        store.commit('navigation/setDrawerOpen', false);
        store.commit('tour/lockNavDrawer', false);
        resolve();
      })
    },
    {
      target: "#treatment-section",
      title: '完善個人資料，快速打造專業形象',
      content: "填寫基本資訊、專長項目與資歷背景，<br>讓患者第一眼就認識您，提升曝光率與預約機會。",
      route: "/settings",
      highlightBgColor: '#ffffff',
      params: {
      },
      // before: async () => {
      //   await waitForElement('#treatment-section')
      // }
    },
    {
      target: "#HealthSection",
      title: '提升影響力，打造個人專業品牌',
      content: "升級訂閱後，可解鎖更多衛教影音與相簿素材，<br>吸引患者注意，提升信任感與預約率！",
      route: "/settings",
      params: {
        placement: vuetify.framework.breakpoint.smAndUp ? 'left' : 'top'
      },
      offset: -300,
      highlightBgColor: '#ffffff',
    },
    {
      target: "#line-social",
      title: '整合社群入口，讓患者主動聯繫你',
      content: "升級後可串接 LINE 官方帳號與社群連結，<br>提升與患者的互動便利性，強化曝光與轉換機會。",
      route: "/settings",
      params: {
        // placement: 'right'
      },
      offset: -80,
      highlightBgColor: '#ffffff',
      before: () => new Promise(async (resolve) => {
        await store.commit('doctorSetting/setEditorDoctor', true);
        resolve();
      }),
      after: () => new Promise((resolve) => {
        console.log(11111)
        store.commit('doctorSetting/setEditorDoctor', false);
        resolve();
      })
    },
    {
      target: "#fake-center-step",
      title: '跨診所預約表',
      content: "若診所有開通系統，即可同步跑點診所預約，<br>隨時掌握接診狀況。",
      route: "/",
      offset: -80,
      highlightBgColor: '#ffffff',
      // params: {
      //   strategy: 'fixed',
      //   placement: 'top-end'
      // },
      before: () => {
        // 如果還沒插入過，就插入一個假 DOM
        if (!document.querySelector('#fake-center-step')) {
          const fakeEl = document.createElement('div')
          fakeEl.id = 'fake-center-step'
          Object.assign(fakeEl.style, {
            position: 'fixed',
            top: '30%',
            left: '50%',
            width: '200px',
            height: '100px',
            transform: 'translate(-50%, -50%)',
            // background: 'rgba(0,0,0,0.05)', // 可加可不加，純測試
            backgroundColor: 'unset',
            zIndex: 9998, // 比 vue-tour tooltip 低一層就好
            pointerEvents: 'none' // 不擋住點擊
          })
          document.body.appendChild(fakeEl)
        }
      }
    },
    {
      target: "#reviewList",
      title: '管理網路評價',
      content: "集中Google評價與小幫手評價回饋，<br>輕鬆掌握病人口碑。",
      route: "/review/list",
      offset: -80,
      highlightBgColor: '#ffffff',
      after: () => new Promise((resolve) => {
        router.push({name: 'home'});
        store.commit('tour/setShowEndObBoardDialog', true);
        resolve();
      })
    }
  ],

  options: {
    ...DEFAULT_OPTIONS,
    showStepsOnBtn: true,
    labels: {
      buttonSkip: 'Skip tour',
      buttonPrevious: 'Previous',
      buttonNext: '下一步',
      buttonStop: '下一步'
    },
    enabledButtons: {
      buttonSkip: false,
      buttonPrevious: false,
      buttonNext: true,
      buttonStop: true
    }
  },

  onStop() {
    store.commit('navigation/setDrawerOpen', false);
  },

  shouldStart(user) {
    if (store.getters['doctorUser']) {
      return localStorage.getItem('isNewUser') && !store.getters['tour/isAnyTourRunning']
    }
    return false
  },

  async onComplete($axios) {
  }
})
